import { render } from "./TextEditor.vue?vue&type=template&id=5e109e84&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Common/TextEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e109e84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e109e84', __exports__)) {
    api.reload('5e109e84', __exports__)
  }
  
  module.hot.accept("./TextEditor.vue?vue&type=template&id=5e109e84&ts=true", () => {
    api.rerender('5e109e84', render)
  })

}


export default __exports__